import React from 'react';
import { SimulationConfig } from './types';
import { SectionLabel } from './SectionLabel';
import { SmartInput } from './SmartInput';

interface DrawerAdvancedSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const DrawerAdvancedSection: React.FC<DrawerAdvancedSectionProps> = ({ config, setConfig }) => (
  <div className="w-full flex flex-col gap-3 p-4 rounded-3xl border bg-emerald-500/5 border-emerald-500/20 mb-4">
    <SectionLabel icon="fa-paint-brush" darkMode={config.darkMode}>Drawer Advanced</SectionLabel>
    <SmartInput label="Line Thickness" min={1} max={10} value={config.drawerLineThickness} onChange={v => setConfig(p => ({...p, drawerLineThickness: v}))} darkMode={config.darkMode} />
    <SmartInput label="Line Opacity" min={0} max={1} step={0.01} value={config.drawerLineOpacity} onChange={v => setConfig(p => ({...p, drawerLineOpacity: v}))} darkMode={config.darkMode} />
    <SmartInput label="Growth Rate" min={0} max={0.2} step={0.001} value={config.growthRate} onChange={v => setConfig(p => ({...p, growthRate: v}))} darkMode={config.darkMode} />
  </div>
);